import { NetworkLog } from './types';

const MAX_LOGS = 150;
const MAX_BODY_CHARS = 20_000;

let idCounter = 0;

export function makeLogId(): string {
    idCounter += 1;
    return `${Date.now().toString(36)}-${idCounter.toString(36)}`;
}

export function truncateBody(body: string | undefined): string | undefined {
    if (body == null) return undefined;
    if (body.length <= MAX_BODY_CHARS) return body;
    return `${body.slice(0, MAX_BODY_CHARS)}\n…[truncated]`;
}

type Listener = () => void;

class NetworkLoggerStore {
    private logs: NetworkLog[] = [];
    private listeners = new Set<Listener>();

    subscribe = (listener: Listener): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };

    getSnapshot = (): NetworkLog[] => this.logs;

    add = (entry: NetworkLog): void => {
        const next = [entry, ...this.logs];
        if (next.length > MAX_LOGS) {
            next.length = MAX_LOGS;
        }
        this.logs = next;
        this.emit();
    };

    update = (id: string, patch: Partial<NetworkLog>): void => {
        let changed = false;
        const next = this.logs.map((log) => {
            if (log.id !== id) return log;
            changed = true;
            return { ...log, ...patch };
        });
        if (!changed) return;
        this.logs = next;
        this.emit();
    };

    clear = (): void => {
        if (this.logs.length === 0) return;
        this.logs = [];
        this.emit();
    };

    private emit(): void {
        this.listeners.forEach((listener) => {
            try {
                listener();
            } catch {
                // a broken listener must never break logging
            }
        });
    }
}

export const networkLoggerStore = new NetworkLoggerStore();
